import React from 'react';

import styled from 'styled-components';

import {AttachTooltip} from 'app/general/overlays';
import {gt} from 'app/utils/i18n';
import {WebPushNotifications} from 'app/utils/web-push-notifications';

import type {PermissionStateType} from 'app/utils/web-push-notifications';
const StyledAlertDiv = styled.div`
  .message {
    flex-grow: 1;
  }

  .buttons {
    flex-shrink: 0;
  }
`;
type Props = Record<string, never>;
type State = {
  isGranted: boolean;
  isDenied: boolean;
};
export class RequestBrowserNotificationAlert extends React.PureComponent<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    if (WebPushNotifications.isSupported())
      this.state = {
        isGranted: WebPushNotifications.permissionIsGranted(),
        isDenied: WebPushNotifications.permissionIsDenied(),
      };
    else
      this.state = {
        isGranted: false,
        isDenied: false,
      };
  }

  requestPermission = (e: React.MouseEvent<any>) => {
    e.preventDefault();
    WebPushNotifications.requestPermission().then(
      (state: PermissionStateType) =>
        this.setState({
          isGranted: state === 'granted',
          isDenied: !(state === 'granted'),
        })
    );
  };

  render() {
    if (!WebPushNotifications.isSupported()) {
      return null;
    }

    const buttonLabel = this.state.isGranted ? gt('On') : gt('Off');
    return (
      <div className="row">
        <StyledAlertDiv className="col alert alert-light d-flex justify-content-between align-items-center clearfix">
          <div className="message d-flex align-items-center">
            <h3 className="mr-2 mb-0">
              <i className="far fa-bell" />
            </h3>
            <div>{gt('Browser notifications')}</div>
          </div>
          <div className="buttons float-right">
            {this.state.isGranted || this.state.isDenied ? (
              <AttachTooltip
                placement="left"
                tooltipContent={
                  this.state.isGranted
                    ? gt(
                        'You may switch browser notifications off in your browser settings.'
                      )
                    : gt(
                        'You may switch browser notifications on in your browser settings.'
                      )
                }
              >
                {(handlers) => (
                  <button className="btn btn-secondary disabled" {...handlers}>
                    {buttonLabel}
                  </button>
                )}
              </AttachTooltip>
            ) : (
              <button
                className="btn btn-primary"
                onClick={this.requestPermission}
              >
                {gt('Turn on')}
              </button>
            )}
          </div>
        </StyledAlertDiv>
      </div>
    );
  }
}
